import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import {
  Slider,
  Select,
  Button as AButton,
  Col,
  Row,
  Icon as AIcon,
  Radio,
  Tooltip,
  Dropdown,
  Menu,
  Input
} from "antd"
import { MoreIcon, CheckedIcon } from "../core/icons"
import Line from "../core/Line"

import Card, { TitleCard, CardHeader } from "../core/Card"
import { getPlans, getInvoices, loadMoreInvoices } from "./actions"
import onMount from "../core/onMount"
import twix from "twix"
import moment from "moment"
import numeral from "numeral"

import Features from "./Features"
import Plans from "./Plans"
import FAQ from "./FAQ"
import ConnectedPlan from "./ConnectedPlan"
import PremiumFeatures from "./PremiumFeatures"

import TeamsUpsellPanel from "./TeamsUpsellPanel"
import GroupDiscountPanel from "./GroupDiscountPanel"
import PotentialCredits from "./PotentialCredits"
import Invoices from "./Invoices"
import PlanLines from "./PlanLines"
import "./Premium.css"
// import PremiumFeatures from "./PremiumFeatures"
import NewStripeForm from "./NewStripeForm"
import Billing from "./Billing"
import Status from "./Status"
import {
  CreateSubModal,
  UpdateSubModal,
  ManageStripeForm,
  CancelOrReactivateSub,
  SurveyModal
} from "./"
import styled from "styled-components"
//
// export const Button = styled(AButton).attrs({
//   type: props => props.primary && "primary"
// })`
//   ${props =>
//     props.link &&
//     `
//     background-color: transparent;
//     border: none;
//     box-shadow: none;
//     color: #444444;
//   `};
//   ${props =>
//     props.pullRight &&
//     `
//     float: right;
//   `};
// `
//
// const HeaderRow = styled(Row)`
//   margin: 0 -20px 10px;
//   padding: 20px;
//   border: none;
//   background-color: #dcf5f1;
//   text-transform: uppercase;
// `

const Manage = props => (
  <div>
    <TitleCard>
      <h1>
        {props.isTeamOwner ? (
          <span style={{ color: "#31B59F" }}>Everlance Teams</span>
        ) : (
          "Everlance Premium"
        )}
      </h1>
    </TitleCard>

    <GroupDiscountPanel user={props.user} />

    <TeamsUpsellPanel user={props.user} />

    <PotentialCredits />

    {!props.isIAP && (
      <div>
        <PlanLines isFetchingPlans={props.isFetchingPlans} />
        <Status />
        <Billing />
        <Invoices
          canLoadMore={props.canLoadMore}
          loadMore={props.loadMoreInvoices}
          isFetchingInvoices={props.isFetchingInvoices}
          data={props.invoices.filter(
            invoice => invoice.billing_reason != "upcoming"
          )}
        />
      </div>
    )}

    <ManageStripeForm />

    <UpdateSubModal />
    <CancelOrReactivateSub />

    <SurveyModal />

    <IAP />
  </div>
)

const IAP = connect(state => ({
  planInterval:
    state.models.user.subscription &&
    state.models.user.subscription.product_identifier ==
      "com.everlance.everlance.premium.monthly"
      ? "Monthly"
      : state.models.user.subscription &&
        state.models.user.subscription.product_identifier ==
          "com.everlance.everlance.premium.yearly"
        ? "Yearly"
        : null
}))(
  ({ planInterval }) =>
    planInterval && (
      <Card>
        <h1 style={{ marginTop: 0 }}>Subscription</h1>

        <p>Plan: Everlance Premium - {planInterval}</p>

        <p>Manage Plan:</p>
        <p>
          Since you purchased your subscription through iTunes, it can only be
          modified through iTunes. To change plans or cancel your subscription,
          on your iPhone, please open the Settings app, then click iTunes, then
          click on your username (or sign in), then View Apple ID, then click on
          Manage, and finally click on Everlance.
        </p>
      </Card>
    )
)

const mapStateToProps = (state, ownProps) => {
  const { plans, invoices, user } = state.models
  const { subs } = state
  return {
    invoices,
    isFetching: user.isFetching,
    isFetchingInvoices: subs.isFetchingInvoices,
    isFetchingPlans: subs.isFetchingPlans,
    hasSubscription: user.hasSubscription,
    user,
    isTeamOwner: !!state.models.user.group_as_enterprise_owner,
    canLoadMore: subs.canLoadMore,
    isIAP: user.subscription.type == "IapSubscription"
  }
}

export default connect(
  mapStateToProps,
  dispatch => {
    return {
      ...bindActionCreators({ loadMoreInvoices }, dispatch),
      dispatch
    }
  }
)(
  onMount(({ dispatch }) => {
    // dispatch(getPlans())
    dispatch(getInvoices())
  })(Manage)
)



// WEBPACK FOOTER //
// ./src/subscriptions/Manage.js